import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const steps = [
  {
    tag: "90 days",
    title: "Trial period",
    paras: [
      "You register an admin account for your school with the button below. This should be done by a leader in your school.",
      "When the admin account is registered and your school is set up, you get a code to share with your fellow teachers, which they can use to sign up.",
      "Teachers are free to register as many classes and generate as many maps as they like. The goal is for them to test out the product.",
    ],
  },
  {
    tag: "One week",
    title: "Before trial ends",
    paras: [
      "One week before the trial ends, we send you an email asking if you want to continue with the subscription.",
      "You get information on how many teachers have registered and how many maps have been created — along with how many hours of manual work, and how much money, have been saved.",
    ],
  },
  {
    tag: "6 months",
    title: "Subscription",
    paras: [
      "Your subscription keeps running as long as you do not cancel.",
      "By default our subscription lasts 6 months, but it can of course be tailored to your preference.",
      "During the trial period, the first 3 months are only charged if you choose to continue with the subscription.",
    ],
  },
  {
    tag: "One week before",
    title: "Invoice",
    paras: [
      "We send you an invoice at latest 1 week before the end of the subscription period. That gives you the chance to terminate before a new one starts.",
      "Once a new period starts, the subscription runs for 6 months unless otherwise specified.",
    ],
  },
];

const GetStarted = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <Header />

      <section className="mx-auto flex max-w-[820px] flex-col gap-4 px-6 pb-6 pt-6 text-center">
        <h1 className="text-[44px] font-bold leading-tight tracking-[-1.5px] text-ink">
          How does a subscription work?
        </h1>
        <p className="mx-auto max-w-[520px] text-base text-muted">
          Hello there! We won't make you read a lot — but here's a quick look at how a subscription works.
        </p>
      </section>

      <section className="mx-auto flex max-w-[820px] flex-col gap-5 px-6 pb-16">
        {steps.map((step, i) => (
          <div key={i} className="flex flex-col gap-4 rounded-4xl bg-surface p-8 shadow-card">
            <div className="flex items-center gap-3.5">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-orange-gradient text-sm font-bold text-white">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="flex flex-col">
                <span className="text-[13px] font-semibold uppercase tracking-wide text-orange_deep">{step.tag}</span>
                <h2 className="text-xl font-bold text-ink">{step.title}</h2>
              </div>
            </div>
            <div className="flex flex-col gap-2.5">
              {step.paras.map((p, j) => (
                <p key={j} className="text-[15px] leading-relaxed text-muted">{p}</p>
              ))}
            </div>
          </div>
        ))}

        <div className="mt-6 flex flex-col items-center gap-4 rounded-4xl bg-surface p-10 text-center shadow-card">
          <a href="http://app.klassekartgenerator.no/signup" className="ds-cta h-14 px-9 text-base">
            Start free trial
          </a>
          <p className="max-w-[420px] text-sm text-muted">
            Start a 90 day free trial. Cancel at any time — and don't worry, we remind you before the trial expires!
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GetStarted;
